$('ul.cakes-thum-slider').slick({
  dots: false, 
  infinite: true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 8,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6, 
        slidesToScroll: 1,
        infinite: true,
        dots: false 
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});


$('ul.indulgence-slider').slick({
  dots: false, 
  infinite: true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});


$('ul.occasions-slider').slick({
  dots:false,
  infinite:true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});


$('ul.home-banner-slider').slick({
  dots:true,
  infinite:true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('ul.cakes-Urgency-slider').slick({
  dots:false,
  infinite:true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});


$('ul.discount-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 6000,
  slidesToShow: 1,
  slidesToScroll: 1
});


$(document).ready(function(){
// Initialize all sliders
$('.product-slider').slick({
    dots: false,  
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('ul.customer-slide').slick({
  dots: true,
  infinite: false,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1
});


$('.home-banner-2').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 2,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});



$(document).ready(function () {
                const $filterButtons = $('.filter-button');
                const $galleryItems = $('.gallery-item');
                $filterButtons.on('click', function () {
                    $filterButtons.removeClass('active');
                    $(this).addClass('active');
                    const filterValue = $(this).data('filter');
                    $galleryItems.each(function () {
                        const $item = $(this);
                        if (filterValue === 'all' || $item.data('category') === filterValue) {
                            $item.show();
                        } else {
                            $item.hide();
                        }
                    });
                });
            }); 


var player;
function onYouTubeIframeAPIReady() {
    player = new YT.Player('videoIframe', {
        events: {
            'onStateChange': onPlayerStateChange
        }
    });
}

$(".play-btn").click(function () {
    $(".body-bg").fadeIn('slow');
    $(".vid-pop").fadeIn('slow');
});

$(".body-bg, i.close-iconss").click(function () {
    $(".body-bg").fadeOut('slow');
    $(".vid-pop").fadeOut('slow');

    // Stop the video for YouTube iframe
    if (player) {
        player.stopVideo(); // This will stop the video
    }
});

  
  
// Tab switching functionality
$('.tab').click(function(e) {
  e.preventDefault()
    const tabId = $(this).data('tab');
    
    // Update active tab
    $('.tab').removeClass('active');
    $(this).addClass('active');
  $('.product-slider').slick('refresh');
    
    // Update active slider
    $('.product-slider').removeClass('active');
    $(`#${tabId}-slider`).addClass('active');
    
    // Refresh the slider
    // $(`#${tabId}-slider`).slick('refresh');
});
});


$(document).ready(function() {
    // When a tab is clicked
    $('.tab1').click(function(e) {
        e.preventDefault();

        // Get the tab ID (featured, bestsellers, new, sale)
        const tabId = $(this).data('tab');

        // Log to verify if we're getting the correct tabId
        console.log(tabId);  // Check this in your browser's console

        // Remove 'active' class from all tabs and sliders
        $('.tab1').removeClass('active');
        $('.product-slider1').removeClass('active');

        // Add 'active' class to the clicked tab and corresponding slider
        $(this).addClass('active');  // Add 'active' to the clicked tab
        $(`#${tabId}`).addClass('active');  // Add 'active' to the corresponding slider

        // Initialize or refresh the slick slider for the active tab
        $(`#${tabId}`).slick('refresh');
    });

});





function switchTab(event, tabId) {
            // Hide all tab contents
            const tabContents = document.getElementsByClassName('tab-content');
            for (let content of tabContents) {
                content.classList.remove('active');
            }

            // Deactivate all tabs
            const tabs = document.getElementsByClassName('tab-button-pro');
            for (let tab of tabs) {
                tab.classList.remove('active');
            }

            // Show the selected tab content and activate the tab
            document.getElementById(tabId).classList.add('active');
            event.currentTarget.classList.add('active');
        }



